import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { customersApiService } from '../../services';

function TicketData() {
  const { id } = useParams();
  const location = useLocation();

  const [inputs, setInputs] = useState({
    ticketNumber: '',
    customerName: '',
    issue_with: '',
    ticketData: '',
    createdBy: '',
    updatedBy: '',
  });

  // Fetch ticket data from Customers API
  const fetchTicketData = useCallback(async () => {
    if (id) {
      try {
        const ticket = await customersApiService.getTicketById(id);
        const createdDate = new Date(ticket.created_at);
        const updatedDate = new Date(ticket.updated_at);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const createdformattedDate = createdDate.toLocaleDateString(
          'en-US',
          options
        );
        const updatedformattedDate = updatedDate.toLocaleDateString(
          'en-US',
          options
        );

        // Fetch fresh customer data to avoid stale cached names
        let customerName = ticket.customer_name;
        try {
          const customer = await customersApiService.getCustomerByNumber(ticket.customer_number);
          if (customer && customer.customer_name) {
            customerName = customer.customer_name;
          }
        } catch (err) {
          console.warn('Could not fetch fresh customer data, using cached name:', err);
        }

        const pageTitle = `${ticket.ticket_number} - ${customerName} - ${ticket.issue_with}`;
        const createdBy = `${ticket.full_name} on ${createdformattedDate}`;
        const updatedBy = `${ticket.full_name} on ${updatedformattedDate}`;
        setInputs(prev => ({
          ...prev,
          ticketNumber: `${ticket.ticket_number}`,
          customerName: customerName,
          issue_with: `${ticket.issue_with}`,
          ticketData: pageTitle,
          createdBy: createdBy,
          updatedBy: updatedBy,
        }));
      } catch (err) {
        console.error('Error fetching ticket from Customers API:', err);
      }
    }
  }, [id]);

  // Initial fetch
  useEffect(() => {
    fetchTicketData();
  }, [fetchTicketData]);

  // Refetch when returning to this route (e.g., after navigating to a tab and back)
  useEffect(() => {
    fetchTicketData();
  }, [location.pathname, fetchTicketData]);

  // Refetch when window gains focus (e.g., after switching tabs)
  useEffect(() => {
    const handleFocus = () => {
      fetchTicketData();
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [fetchTicketData]);

  return (
    <div className="flex items-start pt-4 pl-4">
      <div className=" bg-red-400 p-6 rounded-xl shadow-xl w-1/2 ml-0 text-gray-800">
        <div className="grid grid-cols-6 gap-4 font-semibold text-sm">
          <div className="col-span-6">
            <span className="block mb-1">Ticket name:</span>
            <div className="bg-gray-100 border border-gray-300 rounded-md shadow-md px-3 py-2">
              {inputs.ticketData}
            </div>
          </div>

          <div className="col-span-3">
            <span className="block mb-1">Created by:</span>
            <div className="bg-gray-100 border border-gray-300 rounded-md shadow-md px-3 py-2">
              {inputs.createdBy}
            </div>
          </div>

          <div className="col-span-3">
            <span className="block mb-1">Last Update:</span>
            <div className="bg-gray-100 border border-gray-300 rounded-md shadow-md px-3 py-2">
              {inputs.updatedBy}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TicketData;
